import { useState, useEffect, useCallback } from 'react';
import { subDays, startOfDay, endOfDay } from 'date-fns';
import api from '../api';
import useLogMutations from './useLogMutations';

// Owns the analytics log data for the given date-range window and the
// grade/edit/delete mutations that touch it.
export default function useAnalytics({ rangeDays, isCustomRange, startDate, endDate }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAnalyticsData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      let from, to;
      if (isCustomRange) {
        from = startOfDay(new Date(startDate));
        to = endOfDay(new Date(endDate));
      } else {
        to = endOfDay(new Date());
        from = startOfDay(subDays(new Date(), rangeDays));
      }

      const res = await api.get(
        `/chores/logs/analytics?from=${from.toISOString()}&to=${to.toISOString()}`
      );
      setLogs(res.data);
    } catch (err) {
      console.error(err);
      setError('Could not load analytics data.');
    } finally {
      setLoading(false);
    }
  }, [rangeDays, isCustomRange, startDate, endDate]);

  useEffect(() => { fetchAnalyticsData(); }, [fetchAnalyticsData]);

  const { gradeLog, editLog, deleteLog, editGrade } = useLogMutations(fetchAnalyticsData);

  return { logs, loading, error, gradeLog, editLog, deleteLog, editGrade };
}
